module.exports = __webpack_public_path__ + "static/media/burbuja3.b2fe4ad3.png";